import {createImgIn} from '../ui_utils/DomUtils.ts'
import {ViewPopup} from './ViewPopup.ts'
import {LobbyImage} from '@colonist/types'
import {StorageWrapper} from '../StorageWrapper.ts'
import {ClientPlatformRedirection} from '../ClientPlatformRedirection.ts'

export class UIPortraitModeOptInPopup extends ViewPopup {
    constructor(xAction: () => void) {
        super({key: 'strings:popups.portraitModeOptIn.title'},
            {key: 'strings:popups.portraitModeOptIn.description'},
            () => {
                StorageWrapper.setPortraitModeEnforcementAccepted(true)
                ClientPlatformRedirection.handleRedirectNewAccountsToMobileWeb()
            },
            xAction,
            false, {
                checkButtonCustomContent: {key: 'strings:popups.portraitModeOptIn.okButton'},
                xButtonCustomContent: {key: 'strings:popups.portraitModeOptIn.cancelButton'},
            })
        this.xButton.style.backgroundColor = 'rgba(0, 0, 0, 0.2)'
        const img = createImgIn(this.body, LobbyImage.PortraitModeOptIn, '')
        this.body.prepend(img)
    }
}
